var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('el-form-item',{staticClass:"ss-view-item",attrs:{"label":_vm.label}},[_c('span',[_vm._v(_vm._s(_vm.valueInput?_vm.valueInput:'')+" ")]),_c('span',[_vm._v(_vm._s(_vm.unit)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }